import { CREATE_ANNOUNCEMENT, CREATE_ANNOUNCEMENT_SUCCESS, CREATE_ANNOUNCEMENT_ERROR, CREATE_ANNOUNCEMENT_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateAnnouncementForGlobeToyota = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ANNOUNCEMENT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_ANNOUNCEMENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_ANNOUNCEMENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_ANNOUNCEMENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateAnnouncementForGlobeToyota;
